import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

export const CodeForm = (props) => (
    <form onSubmit={props.handleSubmit}>
        <div>
            <label htmlFor="code">Code: </label>
            <Field id="code" name="code" component="input" type="text"/>
            <br/>
            <img src='robot.png' alt="robot"></img>
            <label htmlFor="isRobot">Are you a robot? </label>
            <Field id="isRobot" name="isRobot" component="input" type="checkbox" />
            <br/>
            <Field name="secret" component="input" type="hidden" />
        </div>
        <button type="submit">Submit</button>
    </form>
)

CodeForm.propTypes = {
    handleSubmit: PropTypes.func,
};

export default reduxForm({
    form: 'code'
})(CodeForm);